import { createSelector, createSlice } from '@reduxjs/toolkit';

const appSettingsSlice = createSlice({
    initialState: {
        settings: [],
        isLoading: false,
    },
    name: 'appSettings',
    reducers: {
        fetchSettings: state => {
            state.settings = [];
            state.isLoading = true;
        },
        settingsFetched: (state, { payload }) => {
            const { results } = payload;

            state.settings = results[0];
            state.isLoading = false;
        },
        settingsFetchedFailed: state => {
            state.isLoading = false;
        },
    },
});

// selectors
const getSelf = state => state.appSettings;

export const getSettings = createSelector(getSelf, state => {
    return state.settings;
});

export const isLoading = createSelector(getSelf, state => state.isLoading);

export const { fetchSettings, settingsFetched, settingsFetchedFailed } =
    appSettingsSlice.actions;
export default appSettingsSlice.reducer;
